/* import __COLOCATED_TEMPLATE__ from './reviewable-conversation-post.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { gte } from "@ember/object/computed";
import TEMPLATE from "./reviewable-conversation-post.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  showUsername: gte("index", 1)
}));